import { useState } from 'react';

import { useT } from '../../i18n';
import { HelligkeitZeile } from '../helligkeit/HelligkeitZeile';
import { useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import { passtPasswort } from './einstellungenSperre';
import styles from './Sheets.module.css';

/**
 * Die Tür vor dem Einstellungsdialog.
 *
 * ⚠️ **`dismissible` bleibt an.** Wer sich vertippt hat oder gar nicht in die Einstellungen
 * wollte, muss zurückkönnen — und hinter dem Dialog liegt hier immer etwas Bedienbares.
 *
 * ⚠️ **Kein Zählwerk, keine Sperrzeit** (s. `einstellungenSperre.ts`): Ein Prüfer, der sich
 * mitten in einer Prüfung aussperrt, ist der teurere Fehler.
 */
export function SperrDialog() {
  const t = useT();
  const erwartet = useAppStore((s) => s.einstellungenPasswort);
  const freigeben = useAppStore((s) => s.setEinstellungenFrei);
  const closeSheet = useAppStore((s) => s.closeSheet);
  const [eingabe, setEingabe] = useState('');
  const [falsch, setFalsch] = useState(false);

  const versuchen = () => {
    if (passtPasswort(eingabe, erwartet)) {
      freigeben(true);
      return;
    }
    // Das Feld wird geleert: ein stehengebliebenes falsches Wort lädt dazu ein, denselben
    // Versuch noch einmal abzuschicken.
    setEingabe('');
    setFalsch(true);
  };

  return (
    <Dialog kicker={t.lock.kicker} title={t.lock.title} onClose={closeSheet} width={420}>
      {/*
        * ⚠️ **Der Helligkeitsregler steht vor dem Schloss** (Entscheidung des Nutzers,
        * 2026-09-17). Er ist die einzige Ausnahme von der Sperre: das Passwort hält den Prüfer
        * von den Prüfungseinstellungen fern, nicht von der Lesbarkeit seines Bildschirms.
        *
        * Er steht **in** diesem Blatt und nicht darüber, weil Radix bei offenem Dialog
        * `pointer-events: none` auf den Body setzt — draussen läge er hinter dem Dunkelfeld und
        * wäre gar nicht bedienbar. Derselbe Regler steht deshalb auch im `SettingsDialog`.
        */}
      <HelligkeitZeile />
      <div className={`sc ${styles.sperrBody}`}>
        <div className={styles.textNote}>{t.lock.hint}</div>
        <label className={styles.textRow}>
          <span className={styles.textLabel}>{t.lock.password}</span>
          <input
            className={styles.textInput}
            type="password"
            value={eingabe}
            autoFocus
            autoCapitalize="off"
            autoCorrect="off"
            onChange={(e) => {
              setEingabe(e.target.value);
              setFalsch(false);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') versuchen();
            }}
          />
        </label>
        {falsch && <div className={styles.sperrFalsch}>{t.lock.wrong}</div>}
        <div className={styles.serverActions}>
          <button type="button" className={`tap ${styles.stufe}`} onClick={versuchen}>
            {t.lock.open}
          </button>
        </div>
      </div>
    </Dialog>
  );
}
